import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Factory, Loader2 } from "lucide-react";

export default function LoginPage() {
  const { user, login, error } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email.trim(), password);
    setLoading(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-50">
      {/* Left visual */}
      <div className="hidden lg:block relative overflow-hidden bg-slate-900">
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage: 'url(https://images.pexels.com/photos/4483942/pexels-photo-4483942.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)',
            backgroundSize: "cover", backgroundPosition: "center",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-slate-950 via-slate-900/60 to-transparent" />
        <div className="relative h-full flex flex-col justify-between p-14 text-white">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-600 grid place-items-center font-display font-black text-xl">M</div>
            <div>
              <div className="font-display font-black text-2xl">MARSELLA BEDDING</div>
              <div className="text-xs tracking-[0.3em] uppercase text-slate-300">Üretim Takip Sistemi</div>
            </div>
          </div>
          <div>
            <div className="text-6xl font-display font-black leading-none">Barkodla<br/>Tam Kontrol.</div>
            <p className="mt-6 max-w-md text-slate-300 leading-relaxed">
              Sipariş, üretim ve sevkiyat sürecinizi tek bir profesyonel platformda yönetin. Her fiziksel parçaya benzersiz barkod.
            </p>
          </div>
          <div className="text-xs tracking-widest uppercase text-slate-400">© 2026 Marsella Bedding</div>
        </div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-6 lg:p-12">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-3 mb-8 lg:hidden">
            <Factory className="text-blue-700" size={28} />
            <div className="font-display font-black text-2xl">MARSELLA</div>
          </div>

          <h1 className="font-display font-black text-4xl text-slate-900">Giriş Yap</h1>
          <p className="text-slate-500 mt-2">Fabrika üretim panelinize erişin.</p>

          <form onSubmit={handleSubmit} className="mt-8 space-y-5" data-testid="login-form">
            <div>
              <label className="block text-xs font-bold uppercase tracking-widest text-slate-600 mb-2">E-posta</label>
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 text-lg font-mono tabular-nums bg-white border-2 border-slate-300 rounded-none focus:border-blue-700 focus:outline-none"
                placeholder="ornek@marsella.com"
              />
            </div>
            <div>
              <label className="block text-xs font-bold uppercase tracking-widest text-slate-600 mb-2">Şifre</label>
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 text-lg font-mono tabular-nums bg-white border-2 border-slate-300 rounded-none focus:border-blue-700 focus:outline-none"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div data-testid="login-error" className="px-4 py-3 bg-red-50 border-2 border-red-500 text-red-800 font-semibold text-sm">
                {error}
              </div>
            )}

            <button
              data-testid="login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 px-6 py-4 bg-blue-700 hover:bg-blue-800 text-white font-bold uppercase tracking-widest rounded-none disabled:opacity-60"
            >
              {loading && <Loader2 size={18} className="animate-spin" />}
              Giriş Yap
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
